import finance from './modules/finance/src';
import fleet from './modules/fleet/src';
import shop from './modules/shop/src';

export default [finance, fleet, shop];
